import { useSelector } from '~/_shared/utils/hooks/useSelector';
import { type AppState } from '~/store/app.store';

const hasNavigatedToHomeSelector = (state: AppState) => state.frontendState.navigation.hasNavigatedToHome;
export const useHasNavigatedToHomeSelector = () => useSelector(hasNavigatedToHomeSelector);
